const ACTIONS = {
    UPDATE_DYNAMIC_LAYOUT: 'DYNAMIC_LAYOUT/UPDATE'
};

const ACTION_CREATORS = {
    updateDynamicLayout(dynamicLayout) {
        return {
            type: ACTIONS.UPDATE_DYNAMIC_LAYOUT,
            payload: {
                dynamicLayout
            }
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
